import { EncodedImage } from "../utils";
import { PacketGenerator } from "../packets";
import { AbstractPrintTask } from "./AbstractPrintTask";

/**
 * @category Print tasks
 */
export class OldD11PrintTask extends AbstractPrintTask {
  override printInit(): Promise<void> {
    return this.protocol.sendAll([
      PacketGenerator.setDensity(this.printOptions.density),
      PacketGenerator.setLabelType(this.printOptions.labelType),
      PacketGenerator.printStart1b(),
    ]);
  }

  override printPage(image: EncodedImage, quantity: number): Promise<void> {
    this.validatePage(image, quantity ?? 1);

    return this.protocol.sendAll(
      [
        PacketGenerator.printClear(),
        PacketGenerator.pageStart(),
        PacketGenerator.setPageSize2b(image.rows),
        PacketGenerator.setPrintQuantity(quantity ?? 1),
        ...PacketGenerator.writeImageData(image, { printheadPixels: this.printheadPixels() }),
        PacketGenerator.pageEnd(),
      ],
      this.printOptions.pageTimeoutMs,
      this.makePacketProgressCallback(),
    );
  }

  override waitForFinished(): Promise<void> {
    return this.protocol.waitUntilPrintFinishedByPageIndex(
      this.printOptions.totalPages ?? 1,
      this.printOptions.statusTimeoutMs
    );
  }
}
